'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  className?: string;
}

const CTASection = ({ className = '' }: CTASectionProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <section className={`py-16 ${className}`}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-primary rounded-lg p-12">
            <div className="h-8 bg-primary-foreground/20 rounded w-96 mx-auto mb-4"></div>
            <div className="h-6 bg-primary-foreground/20 rounded w-full max-w-2xl mx-auto mb-8"></div>
            <div className="flex justify-center gap-4">
              <div className="h-12 bg-primary-foreground/20 rounded w-40"></div>
              <div className="h-12 bg-primary-foreground/20 rounded w-40"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={`py-12 md:py-16 ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-primary rounded-lg p-6 md:p-8 lg:p-12 text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary-foreground mb-3 md:mb-4 break-words">
            Prêt à Découvrir la Différence Services Rouissi ?
          </h2>
          <p className="text-base md:text-lg text-primary-foreground/90 mb-6 md:mb-8 max-w-2xl mx-auto break-words">
            Rejoignez des centaines de clients satisfaits qui nous font confiance pour maintenir leurs espaces impeccables
          </p>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
            <Link
              href="/quote-request"
              className="inline-flex items-center justify-center px-6 md:px-8 py-3 bg-accent text-accent-foreground font-heading font-semibold rounded-lg hover:bg-accent/90 transition-colors duration-300 shadow-lg text-sm md:text-base"
            >
              <Icon
                name="DocumentTextIcon"
                size={20}
                className="mr-2"
                variant="outline"
              />
              Demander un Devis
            </Link>
            <Link
              href="/contact"
              className="inline-flex items-center justify-center px-6 md:px-8 py-3 bg-primary-foreground text-primary font-heading font-semibold rounded-lg hover:bg-primary-foreground/90 transition-colors duration-300 shadow-lg text-sm md:text-base"
            >
              <Icon
                name="PhoneIcon"
                size={20}
                className="mr-2"
                variant="outline"
              />
              Nous Contacter
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;